import { Article } from '@generated'
import { getRcpoModelPrimaryAttributes } from '@lib/get-rcpo-model-primary-attributes'

export function getRcpoModelSeoAttributes(data: Article) {
  const primaryAttributes = getRcpoModelPrimaryAttributes(data)

  let title = `Rolex Certified Pre-Owned`

  if (data.modelName) {
    title += ` ${data.modelName}`
  }

  title += ` | ${primaryAttributes} | GASSAN`

  return {
    title,
    // This will probably change to something else in the future
    description: data.description,
  }
}
